export default {
    'driverPerformanceFunctionTab_coachingEducation_coachingEducation': "Coaching - Education",
    'driverPerformanceFunctionTab_coachingEducation_autoCurateCoachingCases': "Auto Curate Coaching Cases",
    'driverPerformanceFunctionTab_coachingEducation_frequencyDays': "Frequency (Days)",
    'driverPerformanceFunctionTab_coachingEducation_riskScoreGreaterThan': "Risk Score Greater Than",
    'driverPerformanceFunctionTab_coachingEducation_eventsTaggedAsCoachable': "Events Tagged as Coachable",
    'driverPerformanceFunctionTab_coachingEducation_highSeverityEvents': "High Severity Events",
    'driverPerformanceFunctionTab_coachingEducation_mediumSeverityEvents': "Medium Severity Events",
    'driverPerformanceFunctionTab_coachingEducation_updatedConfiguration': "Configuration Saved Successfully",
    'driverPerformanceFunctionTab_coachingEducation_updatedConfigurationError': "Error Saving Configuration",
}